module.exports = __webpack_public_path__ + "static/media/Monday_Step1_Image46.9bcd7748.webp";